export namespace InternalConst {
  export enum Status {
    ACTIVE = 'Active',
    INACTIVE = 'Inactive',
    COMPLETE = 'Complete',
    INCOMPLETE = 'Incomplete'
  }
}
